import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { ROADMAP } from "@/lib/content";

export default function Roadmap() {
    return (
        <section
            id="roadmap"
            className="relative border-t border-white/10 bg-navy-900"
            data-testid="roadmap"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                <Reveal>
                    <SectionLabel index="07">Roadmap</SectionLabel>
                </Reveal>

                <div className="grid gap-px border border-white/10 bg-white/10 lg:grid-cols-3">
                    {ROADMAP.map((phase) => (
                        <Reveal key={phase.phase}>
                            <div className="h-full bg-navy-950 p-8 md:p-10">
                                <div className="flex items-baseline gap-4">
                                    <span className="font-display text-5xl font-light text-gold/30">
                                        {phase.phase}
                                    </span>
                                    <div>
                                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                                            {phase.period}
                                        </p>
                                        <h3 className="mt-1 font-display text-2xl font-light text-white">
                                            {phase.title}
                                        </h3>
                                    </div>
                                </div>
                                <ul className="mt-8 space-y-4">
                                    {phase.points.map((p) => (
                                        <li
                                            key={p}
                                            className="flex gap-3 text-sm leading-relaxed text-white/70"
                                        >
                                            <span className="mt-1.5 h-1 w-1 shrink-0 bg-gold" />
                                            {p}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <div className="mt-8 flex flex-col gap-4 border border-gold/25 bg-gold/[0.05] p-8 md:flex-row md:items-center md:justify-between">
                        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            The Long Arc
                        </span>
                        <p className="font-display text-xl md:text-2xl font-light leading-snug text-white">
                            <span className="text-gold">Phase 1</span> builds the
                            trust. <span className="text-gold">Phase 2</span> turns
                            it into recurring revenue.{" "}
                            <span className="text-gold">Phase 3</span> makes it
                            generational infrastructure.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
